import { Agency, agencyDetailed } from '@app/models';
import { ProgressStatus } from '@app/pcs/models';
import {gql} from 'apollo-angular';


export interface PairAgency {
  id?: number;
  agency?: Agency;
  progressStatus?: ProgressStatus;
  leading?: boolean;
}

export const pairAgency = gql`
  fragment pairAgency on DossierPairAgency {
    id
    agency {
      ...agencyDetailed
    }
    progressStatus {
      id
      description
    }
    leading
  }
  ${agencyDetailed}
`;
